// extracted by mini-css-extract-plugin
export default {"Link":"_Link--ui1g4"};